import React from "react";
import { ReactComponent as CreditCardSvg } from "./common/icon_credit_card.svg";
import { ReactComponent as PillColorSvg } from "./dataRoom/detail/icon_pill_color.svg";
import { ReactComponent as HospitalSvg } from "./signup/icon_hospital.svg";
import { ReactComponent as ArrowDownSvg } from "./common/icon_arrow_down.svg";
import { ReactComponent as ArrowUpSvg } from "./common/icon_arrow_up.svg";
import { ReactComponent as ChevronForwardSvg } from "./common/chevron_forward.svg";
import { ReactComponent as CloseSvg } from "./common/icon_close.svg";
import { ReactComponent as LogoSvg } from "./header/logo.svg";
import { ReactComponent as BackSvg } from "./common/icon_back.svg";
import { ReactComponent as MyEditSvg } from "./common/icon_my_edit.svg";
import { ReactComponent as CommunitySvg } from "./common/navigationBar/icon_bottom_community.svg";
import { ReactComponent as MyIBSSvg } from "./common/icon_my_ibs.svg";
import { ReactComponent as MyMembershipSvg } from "./common/icon_my_credit_card.svg";
import { ReactComponent as MyMatchingSvg } from "./common/icon_my_matching.svg";
import { ReactComponent as MyTermSvg } from "./common/icon_my_term.svg";
import { ReactComponent as MyServiceSvg } from "./common/icon_my_service.svg";
import { ReactComponent as LogoutSvg } from "./common/icon_logout.svg";
import { ReactComponent as LockSvg } from "./matching/icon_lock.svg";

export interface IconProps extends React.SVGProps<SVGSVGElement> {
  width?: string;
  height?: string;
  color?: string;
}

export const CreditCardIcon = ({
  width = "24px",
  height = "24px",
  color,
  ...props
}: IconProps) => (
  <CreditCardSvg width={width} height={height} fill={color} {...props} />
);

export const PillColorIcon = ({
  width = "24px",
  height = "24px",
  color,
  ...props
}: IconProps) => (
  <PillColorSvg width={width} height={height} fill={color} {...props} />
);

export const HospitalIcon = ({
  width = "24px",
  height = "24px",
  color,
  ...props
}: IconProps) => (
  <HospitalSvg width={width} height={height} fill={color} {...props} />
);

export const ArrowDownIcon = ({
  width = "24px",
  height = "24px",
  color,
  ...props
}: IconProps) => (
  <ArrowDownSvg width={width} height={height} fill={color} {...props} />
);

export const ArrowUpIcon = ({
  width = "24px",
  height = "24px",
  color,
  ...props
}: IconProps) => (
  <ArrowUpSvg width={width} height={height} fill={color} {...props} />
);

export const ChevronForwardIcon = ({
  width = "24px",
  height = "24px",
  color,
  ...props
}: IconProps) => (
  <ChevronForwardSvg width={width} height={height} fill={color} {...props} />
);

export const CloseIcon = ({
  width = "24px",
  height = "24px",
  color,
  ...props
}: IconProps) => (
  <CloseSvg width={width} height={height} fill={color} {...props} />
);

export const LogoIcon = ({
  width = "123px",
  height = "34px",
  color,
  ...props
}: IconProps) => (
  <LogoSvg width={width} height={height} fill={color} {...props} />
);

export const BackIcon = ({
  width = "24px",
  height = "24px",
  color,
  ...props
}: IconProps) => (
  <BackSvg width={width} height={height} fill={color} {...props} />
);

export const MyEditIcon = ({
  width = "24px",
  height = "24px",
  color,
  ...props
}: IconProps) => (
  <MyEditSvg width={width} height={height} fill={color} {...props} />
);
export const MyCommunity = ({
  width = "24px",
  height = "24px",
  color,
  ...props
}: IconProps) => (
  <CommunitySvg width={width} height={height} fill={color} {...props} />
);

export const MyIBSIcon = ({
  width = "24px",
  height = "24px",
  color,
  ...props
}: IconProps) => (
  <MyIBSSvg width={width} height={height} fill={color} {...props} />
);

export const MyMembershipIcon = ({
  width = "24px",
  height = "24px",
  color,
  ...props
}: IconProps) => (
  <MyMembershipSvg width={width} height={height} fill={color} {...props} />
);

export const MyMatchingIcon = ({
  width = "24px",
  height = "24px",
  color,
  ...props
}: IconProps) => (
  <MyMatchingSvg width={width} height={height} fill={color} {...props} />
);

export const MyTermIcon = ({
  width = "24px",
  height = "24px",
  color,
  ...props
}: IconProps) => (
  <MyTermSvg width={width} height={height} fill={color} {...props} />
);

export const MyServiceIcon = ({
  width = "24px",
  height = "24px",
  color,
  ...props
}: IconProps) => (
  <MyServiceSvg width={width} height={height} fill={color} {...props} />
);

export const LogoutIcon = ({
  width = "24px",
  height = "24px",
  color,
  ...props
}: IconProps) => (
  <LogoutSvg width={width} height={height} fill={color} {...props} />
);

export const LockIcon = ({
  width = "24px",
  height = "24px",
  color,
  ...props
}: IconProps) => (
  <LockSvg width={width} height={height} fill={color} {...props} />
);
